import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
    const navigate = useNavigate();
    const processed = useRef(false);
    const { refresh } = useAuth();

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/auth", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(match[1]);
        (async () => {
            try {
                await api.post("/auth/emergent-session", { session_id });
                await refresh();
                // clear hash and go home
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/", { replace: true });
            } catch {
                navigate("/auth?error=1", { replace: true });
            }
        })();
    }, [navigate, refresh]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-[hsl(var(--dust-50))]" data-testid="auth-callback">
            <div className="font-display text-4xl uppercase italic text-[hsl(var(--ink))]">Signing you in…</div>
        </div>
    );
}
